// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2RlLu","actionsCol":"EnrolledClinics_actionsCol__1HgxZ"};